import { render, staticRenderFns } from "./product-view.vue?vue&type=template&id=7f01fd83&scoped=true"
import script from "./product-view.vue?vue&type=script&lang=js"
export * from "./product-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01fd83",
  null
  
)

export default component.exports